var utbildning = (function () {
  var tillfalleskarusell;

  function hanteraLangTextPaTillfalle() {
    tillfalleskarusell
      .querySelectorAll(".js-tillfalle-kort-utfallning")
      .forEach(function (elem, index) {
        if (!elem.classList.contains("kapad")) {
          let elementText = elem.textContent.trim();
          const resten = elementText.length - 160;
          if (elementText.length > 160 && resten > 100) {
            const entryRequirementsLank = elem.querySelector(
              ".entryRequirementsLank"
            );
            if (entryRequirementsLank) {
              let linktext = entryRequirementsLank.textContent.trim();
              elementText = elementText.substring(
                0,
                elementText.length - linktext.length
              );
            }
            let borjan = elementText.substring(0, 160);
            const brytpunkt = borjan.lastIndexOf(" ");
            borjan = elementText.substring(0, brytpunkt);
            const slutet = elementText.substring(brytpunkt, elementText.length);
            elem.textContent = borjan;
            elem.classList.add("kapad");

            let rubrik =
              elem.parentNode.parentNode.firstElementChild.textContent;
            rubrik = rubrik.replace(":", "");
            const avslutId = "avslut" + index;

            let avslut = document.createElement("span");
            avslut.className = "d-none avslut";
            avslut.textContent = slutet;
            avslut.setAttribute("id", avslutId);
            avslut.setAttribute("tabindex", "-1");
            if (entryRequirementsLank) {
              avslut.appendChild(entryRequirementsLank);
            }

            let knapp = skapaKnapp(avslutId, "js-visa-mer-lank", rubrik);
            insertAfter(knapp, elem);
            insertAfter(avslut, elem);

            knapp.addEventListener("click", function () {
              let borjan = this.parentNode.querySelector(
                ".js-tillfalle-kort-utfallning"
              );
              borjan.classList.toggle("kapad");

              let slutet = this.parentNode.querySelector(".avslut");
              slutet.classList.toggle("d-none");

              vaxlaKnapp(this, avslutId, rubrik);
            });
          }
        }
      });
  }

  function studieavgifter() {
    tillfalleskarusell
      .querySelectorAll(".js-studieavgifter-utokat-innehall")
      .forEach(function (elem, index) {
        if (!elem.classList.contains("js-kapad")) {
          elem.classList.add("js-kapad");
          elem.setAttribute("id", "studieavgifter" + index);
          elem.setAttribute("tabindex", "-1");
          elem.classList.add("d-none");

          let rubrik = elem.parentNode.parentNode.firstElementChild.textContent;
          rubrik = rubrik.replace(":", "");

          let knapp = skapaKnapp(
            "studieavgifter" + index,
            "js-visa-mer-lank-studieavgifter",
            rubrik
          );
          insertAfter(knapp, elem);

          knapp.addEventListener("click", function () {
            let utokatInnehall = this.parentNode.querySelector(
              ".js-studieavgifter-utokat-innehall"
            );
            utokatInnehall.classList.toggle("d-none");

            vaxlaKnapp(this, "studieavgifter" + index, rubrik);
          });
        }
      });
  }

  function skapaKnapp(id, klass, rubrik) {
    let knapp = document.createElement("button");
    knapp.className = "btn btn-link " + klass;
    knapp.setAttribute("aria-expanded", "false");
    knapp.setAttribute("aria-controls", id);

    let lasMerText = document.createElement("span");
    lasMerText.className = "las-mer";
    lasMerText.setAttribute("aria-hidden", "true");
    lasMerText.textContent = document.getElementById("LasMerText").value;

    let doljText = document.createElement("span");
    doljText.className = "dolj d-none";
    doljText.setAttribute("aria-hidden", "true");
    doljText.textContent = document.getElementById("DoljText").value;

    let omText = document.createElement("span");
    omText.className = "visually-hidden";
    omText.textContent =
      document.getElementById("LasMerOm").value + " " + rubrik;

    knapp.appendChild(lasMerText);
    knapp.appendChild(doljText);
    knapp.appendChild(omText);
    return knapp;
  }

  function vaxlaKnapp(knapp, id, rubrik) {
    let doljText = knapp.querySelector(".dolj");
    doljText.classList.toggle("d-none");

    let lasMerText = knapp.querySelector(".las-mer");
    lasMerText.classList.toggle("d-none");

    let srOnlyText = knapp.querySelector(".visually-hidden");
    let lasMerOmText = document.getElementById("LasMerOm").value + " " + rubrik;
    if (knapp.getAttribute("aria-expanded") === "true") {
      knapp.setAttribute("aria-expanded", "false");
      srOnlyText.textContent = lasMerOmText;
    } else {
      knapp.setAttribute("aria-expanded", "true");
      srOnlyText.textContent =
        document.getElementById("DoljText").value + " " + lasMerOmText;
      document.getElementById(id).focus();
    }
  }

  function disableCarouselBtn() {
    let carouselControlPrev = tillfalleskarusell.querySelector(
      ".carousel-control-prev"
    );
    let carouselControlNext = tillfalleskarusell.querySelector(
      ".carousel-control-next"
    );
    let carouselInner = tillfalleskarusell.querySelector(".carousel-inner");

    carouselControlPrev.disabled = false;
    carouselControlNext.disabled = false;

    if (carouselInner.lastElementChild.classList.contains("active")) {
      carouselControlNext.disabled = true;
    }

    if (carouselInner.firstElementChild.classList.contains("active")) {
      carouselControlPrev.disabled = true;
    }
  }

  function insertAfter(newNode, existingNode) {
    existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
  }

  /* ********** Exponerade funktioner     */
  function initUtbildning() {
    tillfalleskarusell = document.getElementById("tillfalleskarusell");
    if (tillfalleskarusell) {
      hanteraLangTextPaTillfalle();
      studieavgifter();
      disableCarouselBtn();

      tillfalleskarusell.addEventListener("slid.bs.carousel", function () {
        let carouselInner = this.querySelector(".carousel-inner");
        let termText = carouselInner.querySelector(".active .termin");
        let term = this.querySelector("#termin");
        term.textContent = termText.textContent;

        let snabbfaktatermin = document.getElementById("snabbfaktatermin");
        snabbfaktatermin.textContent = termText.textContent;

        let kurserikurspaket = document.getElementById("kurserikurspaket");
        if (kurserikurspaket) {
          let kurser = carouselInner.querySelector(".active .kurspaketkurser");
          if (kurser) {
            kurserikurspaket.innerHTML = kurser.innerHTML;
          }
        }

        disableCarouselBtn();
      });
    }
  }

  /* ********** Returnera exponerat gränssnitt     */
  return {
    initUtbildning: initUtbildning,
  };
})();

export default utbildning;
